export const AnimationDuration = {
  Shake: '0.4s',
  Rotate: '1s',
  DatePickerReveal: '0.3s',
  PopupReveal: '0.3s',
  TooltipOpening: '0.3s',
};
